import script from "./Documents.vue?vue&type=script&setup=true&lang=ts"
export * from "./Documents.vue?vue&type=script&setup=true&lang=ts"

import "./Documents.vue?vue&type=style&index=0&id=4853f867&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4853f867"]])

export default __exports__